export const selectAttendanceMeetingType = (state) =>
  state.attendance.selectedMeetingType;
